// src/templates/sampleRequestEmail.tsx

export const DEFAULT_SUBJECT = "Congratulations! Spicy Cubes Sample Video Request";

// Separate the header and footer from the editable content
const EMAIL_HEADER = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Spicy Cubes Sample Video Request</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #000;
            background-color: #fff;
            margin: 0;
            padding: 20px;
        }
        a {
            color: #5E150F;
            text-decoration: underline;
        }
        .container {
            max-width: 600px;
            margin: 0 auto;
        }
        .highlight-box {
            background-color: #f8f9fa;
            padding: 20px;
            border-radius: 8px;
            margin: 20px 0;
        }
        .button {
            display: inline-block;
            background-color: #5E150F;
            color: #F7E8CC !important;
            padding: 12px 24px;
            text-decoration: none;
            border-radius: 6px;
            font-weight: bold;
        }
        .text-center {
            text-align: center;
        }
    </style>
</head>
<body>
<div class="container">`;

const EMAIL_FOOTER = `
</div>
</body>
</html>`;

// Only the editable content
export const getEditableContent = (firstName: string) => `
    <h2>Congratulations, ${firstName}!</h2>
    
    <p>We're excited to inform you that you've made it to the final stage of our selection process for <strong>Spicy Cubes</strong>!</p>
    
    <div class="highlight-box">
        <h3 style="margin-top: 0;">Sample Video Details</h3>
        <ul style="list-style: none; padding: 0;">
            <li style="margin-bottom: 10px;">💰 Compensation: <strong>$30</strong> upon submission</li>
            <li style="margin-bottom: 10px;">📝 Required: One sample video following our guidelines</li>
            <li style="margin-bottom: 10px;">⏰ Timeline: Submit at your earliest convenience</li>
        </ul>
    </div>

    <p>We've prepared a detailed brief with instructions and examples to help guide your creative process. Once your video is ready, please submit it via the Sample Video Request Form included in the brief.</p>

    <div class="text-center" style="margin: 30px 0;">
        <a href="https://spicycubes.creatorform.co/high-interest-candidate-application" 
           target="_blank" 
           rel="noopener noreferrer"
           class="button">
            View Sample Video Instructions
        </a>
    </div>

    <p>If you have any questions or need assistance, please don't hesitate to reach out to us. We're looking forward to seeing your creative work!</p>

    <p>Best regards,<br>
    <strong>Ashli</strong><br>
    Spicy Cubes</p>`;

// Full template for sending with subject
export const getFullEmailTemplate = (content: string, subject: string = DEFAULT_SUBJECT) => ({
  subject,
  body: `${EMAIL_HEADER}${content}${EMAIL_FOOTER}`
});